import React from "react";
import Login from "../fragments/login";

export default class LoginPage extends React.Component {

    render() {
        return (
            <div>
                <div id="headerBar"></div>
                <div style={
                    {
                        "display": "flex",
                        "justifyContent": "center",
                        "paddingTop": "180px"
                    }
                }>
                    <Login pageProps={this.props}></Login>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/jsx/components/pages/login-page.jsx